"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var I18n = require("i18n-js");
var React = require("react");
var lodash_1 = require("lodash");
var classNames = require("classnames");
var bind_1 = require("../bind");
var mparticle_tracker_1 = require("../elog/mparticle_tracker");
var FollowRow = /** @class */ (function (_super) {
    tslib_1.__extends(FollowRow, _super);
    function FollowRow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            confirmRemove: false,
        };
        return _this;
    }
    FollowRow.prototype.delete = function (e) {
        e.preventDefault();
        mparticle_tracker_1.trackEvent({
            eventName: mparticle_tracker_1.MParticleEventName.RemovedFollow,
            followId: this.props.follow.id,
        });
        this.props.actions.deleteFollow(this.props.follow);
    };
    FollowRow.prototype.toggleConfirm = function (e) {
        e.preventDefault();
        this.setState({ confirmRemove: !this.state.confirmRemove });
    };
    FollowRow.prototype.link = function () {
        if (!this.props.follow) {
            return '#';
        }
        return lodash_1.get(this.props.follow, '_links.search.href', '');
    };
    FollowRow.prototype.followHasAlert = function (props) {
        var hasAlert = lodash_1.get(props, 'follow.alert') || false;
        var hasDigestEnabled = lodash_1.get(props, 'follow.digest_enabled') || false;
        return hasAlert || hasDigestEnabled;
    };
    FollowRow.prototype.shouldAddAlert = function () {
        return !this.followHasAlert(this.props);
    };
    FollowRow.prototype.toggleGearAlert = function (e) {
        e.preventDefault();
        if (this.shouldAddAlert()) {
            this.props.actions.addGearAlert(this.props.follow);
            return;
        }
        this.props.actions.removeGearAlert(this.props.follow);
    };
    FollowRow.prototype.renderDetails = function () {
        if (!this.props.follow.subtitle) {
            return this.props.follow.header;
        }
        return (React.createElement("a", { href: this.link() },
            this.props.follow.header,
            React.createElement("small", null, this.props.follow.subtitle)));
    };
    FollowRow.prototype.gearAlertTooltipText = function () {
        if (this.shouldAddAlert()) {
            return I18n.t('commons.addFollowToFeed.addToGearAlerts');
        }
        return I18n.t('commons.addFollowToFeed.removeFromGearAlerts');
    };
    FollowRow.prototype.renderGearAlertButton = function () {
        if (!lodash_1.get(this.props, 'follow._links.alert') && !this.props.enableDigestToggle)
            return;
        var classes = classNames('feed-customize__item__action', { 'feed-customize__item__action--add-gear-alert': this.shouldAddAlert() }, { 'feed-customize__item__action--remove-gear-alert': !this.shouldAddAlert() });
        return (React.createElement("a", { className: classes, onClick: this.toggleGearAlert, "data-tooltip-text": this.gearAlertTooltipText() }));
    };
    FollowRow.prototype.renderImage = function () {
        if (!lodash_1.get(this.props, 'follow._links.image.href')) {
            return;
        }
        var src = this.props.follow._links.image.href;
        return (React.createElement("a", { className: "feed-customize__item__image", href: this.link(), style: { backgroundImage: "url('" + src + "')" } }));
    };
    FollowRow.prototype.renderActions = function () {
        return (React.createElement("div", { className: "feed-customize__item__actions" },
            React.createElement("a", { href: this.link(), className: "feed-customize__item__action feed-customize__item__action--visit", "data-tooltip-text": I18n.t('commons.addFollowToFeed.followSearch') }),
            this.renderGearAlertButton(),
            React.createElement("a", { href: "#", onClick: this.toggleConfirm, className: "feed-customize__item__action feed-customize__item__action--confirm", "data-tooltip-text": I18n.t('commons.addFollowToFeed.remove.removeFromFeed') })));
    };
    FollowRow.prototype.renderFollow = function () {
        var classes = classNames('feed-customize__item', { 'feed-customize__item--placeholder': !this.props.follow });
        return (React.createElement("div", { className: classes },
            React.createElement("div", { className: "feed-customize__item__main" },
                this.renderImage(),
                React.createElement("div", { className: "feed-customize__item__details" }, this.props.follow && this.renderDetails())),
            this.props.actions && this.renderActions()));
    };
    FollowRow.prototype.renderConfirm = function () {
        return (React.createElement("div", { className: 'feed-customize__item feed-customize__item--confirm-remove' },
            React.createElement("div", { className: "feed-customize__item__confirm-remove-wrapper" },
                React.createElement("div", { className: "feed-customize__item__confirm-remove-title" }, I18n.t('commons.addFollowToFeed.remove.areYouSure')),
                React.createElement("a", { href: "#", onClick: this.delete, className: "feed-customize__item__confirm-remove-button" }, I18n.t('commons.addFollowToFeed.remove.confirm')),
                React.createElement("a", { href: "#", onClick: this.toggleConfirm, className: "feed-customize__item__confirm-remove-button" }, I18n.t('commons.addFollowToFeed.remove.cancel')),
                React.createElement("p", { className: "feed-customize__item__confirm-remove-hint" }, I18n.t('commons.addFollowToFeed.remove.removeHint')))));
    };
    FollowRow.prototype.render = function () {
        if (this.state.confirmRemove) {
            return this.renderConfirm();
        }
        return this.renderFollow();
    };
    tslib_1.__decorate([
        bind_1.default
    ], FollowRow.prototype, "delete", null);
    tslib_1.__decorate([
        bind_1.default
    ], FollowRow.prototype, "toggleConfirm", null);
    tslib_1.__decorate([
        bind_1.default
    ], FollowRow.prototype, "toggleGearAlert", null);
    return FollowRow;
}(React.Component));
exports.default = FollowRow;
//# sourceMappingURL=follow_row.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/follow_row.js
// module id = Wkks
// module chunks = 0 2 3 20